import { X } from "lucide-react";

/** 为 Arco 弹层提供可聚焦且中文命名的关闭控件。 */
export function ItineraryDialogCloseButton({ label, onClick }: { label: string; onClick?: () => void }) {
  return (
    <button type="button" className="itinerary-dialog-close" aria-label={label} title={label} onClick={onClick}>
      <X size={18} aria-hidden="true" />
    </button>
  );
}
